import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news11_1 from "../../images/news/news11_1.jpg";
import news11_2 from "../../images/news/news11_2.jpg";
import news11_3 from "../../images/news/news11_3.jpg";
import news11_4 from "../../images/news/news11_4.jpg";
import news11_5 from "../../images/news/news11_5.jpg";
import news11_6 from "../../images/news/news11_6.jpg";
import news11_7 from "../../images/news/news11_7.jpg";
import news11_8 from "../../images/news/news11_8.jpg";
import news11_9 from "../../images/news/news11_9.jpg";
import news11_10 from "../../images/news/news11_10.jpg";
import news11_11 from "../../images/news/news11_11.jpg";
import news11_12 from "../../images/news/news11_12.jpg";
import news11_13 from "../../images/news/news11_13.jpg";
import news11_14 from "../../images/news/news11_14.jpg";
import news11_15 from "../../images/news/news11_15.jpg";

import { withTranslation } from "react-i18next";

class news11 extends Component {
    componentDidMount() { }

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News11_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News11_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News11_LinkHome")}</Link>
                                </li>
                                <li>{t("News11_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            <h1>{t("News11_Content_H")}</h1>


                                            {/* P1 */}
                                            <p>{t("News11_P1_MD")}</p>

                                            {/* IMG 1 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news11_1}
                                                    alt={t("News11_IMG1_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG1_DESC")}
                                                </div>
                                            </div>

                                            {/* P2_1 */}
                                            <p>{t("News11_P2_MD_1")}</p>

                                            {/* P2_2 */}
                                            <h3>{t("News11_P2_MD_2")}</h3>

                                            {/* P2_3 */}
                                            <p>{t("News11_P2_MD_3")}</p>

                                            {/* P2_4 */}
                                            <p>{t("News11_P2_MD_4")}</p>

                                            {/* IMG 2 & IMG 3 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div style={{ display: "flex", justifyContent: "center", gap: 0, flexWrap: "wrap" }}>
                                                    <img
                                                        src={news11_2}
                                                        alt={t("News11_IMG2_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                    <img
                                                        src={news11_3}
                                                        alt={t("News11_IMG3_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                </div>

                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG3_DESC")}
                                                </div>
                                            </div>



                                            {/* P4_1 */}
                                            <p>{t("News11_P4_MD_1")}</p>

                                            {/* P4_2 */}
                                            <p>{t("News11_P4_MD_2")}</p>

                                            {/* IMG 4 & IMG 5*/}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div style={{ display: "flex", justifyContent: "center", gap: 0, flexWrap: "wrap" }}>
                                                    <img
                                                        src={news11_4}
                                                        alt={t("News11_IMG4_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                    <img
                                                        src={news11_5}
                                                        alt={t("News11_IMG5_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}

                                                    />
                                                </div>

                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG5_DESC")}
                                                </div>
                                            </div>

                                            {/* P6_1 */}
                                            <h3>{t("News11_P6_MD_1")}</h3>

                                            {/* P6_2 */}
                                            <p>{t("News11_P6_MD_2")}</p>

                                            {/* P6_3 */}
                                            <p>{t("News11_P6_MD_3")}</p>

                                            {/* IMG 6 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news11_6}
                                                    alt={t("News11_IMG6_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG6_DESC")}
                                                </div>
                                            </div>

                                            {/* P7_1 */}
                                            <strong>{t("News11_P7_MD_1")}</strong>

                                            {/* P7_2 */}
                                            <p>{t("News11_P7_MD_2")}</p>

                                            {/* IMG 7 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news11_7}
                                                    alt={t("News11_IMG7_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG7_DESC")}
                                                </div>
                                            </div>

                                            {/* P8_1 */}
                                            <strong>{t("News11_P8_MD_1")}</strong>

                                            {/* P8_2 */}
                                            <p>{t("News11_P8_MD_2")}</p>

                                            {/* IMG 8 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news11_8}
                                                    alt={t("News11_IMG8_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG8_DESC")}
                                                </div>
                                            </div>

                                            {/* P9_1 */}
                                            <strong>{t("News11_P9_MD_1")}</strong>

                                            {/* P9_2 */}
                                            <p>{t("News11_P9_MD_2")}</p>

                                            {/* IMG 9 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news11_9}
                                                    alt={t("News11_IMG9_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG9_DESC")}
                                                </div>
                                            </div>

                                            {/* P10_1 */}
                                            <h3>{t("News11_P10_MD_1")}</h3>

                                            {/* P10_2 */}
                                            <p>{t("News11_P10_MD_2")}</p>

                                            {/* IMG 10 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news11_10}
                                                    alt={t("News11_IMG10_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG10_DESC")}
                                                </div>
                                            </div>

                                            {/* P11 */}
                                            <p>{t("News11_P11_MD")}</p>

                                            {/* IMG 11 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news11_11}
                                                    alt={t("News11_IMG11_DESC")}
                                                />
                                                <div style={{ marginTop: "11px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG11_DESC")}
                                                </div>
                                            </div>

                                            {/* P12_1 */}
                                            <h3>{t("News11_P12_MD_1")}</h3>

                                            {/* P12_2 */}
                                            <p>{t("News11_P12_MD_2")}</p>

                                            {/* P12_3 */}
                                            <p>{t("News11_P12_MD_3")}</p>

                                            {/* IMG 12 & IMG 13 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div style={{ display: "flex", justifyContent: "center", gap: 0, flexWrap: "wrap" }}>
                                                    <img
                                                        src={news11_12}
                                                        alt={t("News11_IMG12_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                    <img
                                                        src={news11_13}
                                                        alt={t("News11_IMG13_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                </div>
                                                <div style={{ marginTop: "13px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG13_DESC")}
                                                </div>
                                            </div>

                                            {/* P14 */}
                                            <p>{t("News11_P14_MD")}</p>

                                            {/* IMG 14 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news11_14}
                                                    alt={t("News11_IMG14_DESC")}
                                                />
                                                <div style={{ marginTop: "14px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG14_DESC")}
                                                </div>
                                            </div>

                                            {/* P15_1 */}
                                            <strong>{t("News11_P15_MD_1")}</strong>

                                            {/* P15_2 */}
                                            <p>{t("News11_P15_MD_2")}</p>

                                            {/* P15_3 */}
                                            <p>{t("News11_P15_MD_3")}</p>

                                            {/* P15_4 */}
                                            <p>{t("News11_P15_MD_4")}</p>

                                            {/* P15_5 */}
                                            <p>{t("News11_P15_MD_5")}</p>

                                            {/* IMG 15 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news11_15}
                                                    alt={t("News11_IMG15_DESC")}
                                                />
                                                <div style={{ marginTop: "15px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News11_IMG15_DESC")}
                                                </div>
                                            </div>

                                            {/* P16_1 */}
                                            <strong>{t("News11_P16_MD_1")}</strong>

                                            {/* P16_2 */}
                                            <p>{t("News11_P16_MD_2")}</p>

                                            {/* P16_3 */}
                                            <p>{t("News11_P16_MD_3")}</p>

                                            {/* P16_4 */}
                                            <p>{t("News11_P16_MD_4")}</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </>

        );
    }
}

export default news11 = withTranslation()(news11);
